<template>
  <v-app>
    <navigation v-if="!$route.meta.hideNavigation" :mobile="$vuetify.breakpoint.mdAndDown" />
    <v-content :style='syncFromAppToCockpitAllowed ? "" : "margin-top: 2rem"'>
      <router-view/>
    </v-content>
    <message-bar />
    <cookie-consent />
    <sync-service v-if="!$route.meta.hideNavigation" />
    <footer-bar />
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { RunStates } from '@/libs/signalR/vuexStore/store/state';
import CookieConsent from './components/CookieConsent';
import Navigation from './components/Navigation';
import MessageBar from './components/MessageBar';
import FooterBar from './components/FooterBar';
import SyncService from './components/SyncService';
// import StatusUpdater from './components/StatusUpdater';

export default {
  name: 'App',
  data: () => ({
    self: this
  }),
  components: {
    CookieConsent,
    Navigation,
    MessageBar,
    FooterBar,
    SyncService,
    // StatusUpdater,
  },
  computed: {
    ...mapGetters(['syncFromAppToCockpitAllowed']),
    ...mapState({
      user: (state) => state.user,
      runInfo: (state) => state.runInfo,
      runState: (state) => state.signalR.runState
    }),
  },
  methods: {
    handleRunStateChange() {
      // console.log(this.runState === RunStates.RunEdit)
      if (this.runState === RunStates.RunEdit) {
        this.$router.push({ name: 'blocker' });
      } else {
        // todo redirect to loader, which in turn redirects to overview -> maybe fetching the appRun again to verify the user still has access
        this.$router.push({ name: 'loader' });
        // this.$router.push({ name: 'overview' })
      }
    }
  },
  watch: {
    runState() {
      if (this.$route.path.startsWith('/loader')) return;
      this.handleRunStateChange()
    }
  }
};
</script>
